import React from 'react';
import { useDispatch } from 'react-redux';
import TextFieldComponent from '../components/TextFieldComponent';
import ButtonComponent from '../components/ButtonComponent';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import CheckboxComponent from '../components/CheckBoxComponent';
import { createSubscriptionPlan, updateSubscriptionPlan } from '../redux/actions/commonActions';

const validationSchema = Yup.object().shape({
    planName: Yup.string().required('Plan Name is required'),
    price: Yup.number().positive("Price must be greater than 0").required('Price is required'),
    totalMonths: Yup.number().positive("Total Months must be greater than 0").required('Total Months is required'),
    noOfJobPosts: Yup.number().positive("No of Job Posts must be greater than 0").required('No of Job Posts is required'),
    discount: Yup.number().positive("Discount must be greater than 0").nullable()
});

const AddSubscriptionPlan = ({ onClose, subscriptionPlanDetail, onNewSubscriptionPlanAdded }) => {
    const dispatch = useDispatch();

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            planName: subscriptionPlanDetail?.planName || '',
            planDescription: subscriptionPlanDetail?.planDescription || '',
            price: subscriptionPlanDetail?.price || '',
            totalMonths: subscriptionPlanDetail?.totalMonths || null,
            noOfJobPosts: subscriptionPlanDetail?.noOfJobPosts || null,
            discount: subscriptionPlanDetail?.discount || null,
            isActive: subscriptionPlanDetail ? subscriptionPlanDetail.active : true
        },
        validationSchema: validationSchema,

        onSubmit: async (values) => {

            if (subscriptionPlanDetail) {
                await dispatch(updateSubscriptionPlan(subscriptionPlanDetail.id, values));
                onClose();
            } else {
                await dispatch(createSubscriptionPlan(values));
                onNewSubscriptionPlanAdded();
                onClose();
            }
            formik.resetForm();
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <TextFieldComponent
                label="Plan Name *"
                type="text"
                field={{
                    ...formik.getFieldProps('planName'),
                    onChange: formik.handleChange('planName'),
                }}
                form={formik}
                fullWidth
                style={{ marginBottom: '16px' }}
            />

            <TextFieldComponent
                label="Plan Description"
                type="text"
                multiline={true}
                rows={3}
                field={{
                    ...formik.getFieldProps('planDescription'),
                    onChange: formik.handleChange('planDescription'),
                }}
                form={formik}
                fullWidth
                style={{ marginBottom: '16px' }}
            />

            <TextFieldComponent
                label="Price *"
                type="tel"
                inputmode="numeric"
                pattern="[0-9\s]{13,19}"
                field={{
                    ...formik.getFieldProps('price'),
                    onChange: formik.handleChange('price'),
                }}
                form={formik}
                fullWidth
                style={{ marginBottom: '16px' }}
            />

            <TextFieldComponent
                label="Total Months *"
                type="tel"
                inputmode="numeric"
                pattern="[0-9\s]{13,19}"
                field={{
                    ...formik.getFieldProps('totalMonths'),
                    onChange: formik.handleChange('totalMonths'),
                }}
                form={formik}
                fullWidth
                style={{ marginBottom: '16px' }}
                disabled={subscriptionPlanDetail}
            />

            <TextFieldComponent
                label="No of Job Posts allowed *"
                type="tel"
                inputmode="numeric"
                pattern="[0-9\s]{13,19}"
                field={{
                    ...formik.getFieldProps('noOfJobPosts'),
                    onChange: formik.handleChange('noOfJobPosts'),
                }}
                form={formik}
                fullWidth
                style={{ marginBottom: '16px' }}
                disabled={subscriptionPlanDetail}
            />

            <TextFieldComponent
                label="Discount %"
                type="tel"
                inputmode="numeric"
                pattern="[0-9\s]{13,19}"
                field={{
                    ...formik.getFieldProps('discount'),
                    onChange: formik.handleChange('discount'),
                }}
                form={formik}
                fullWidth
                style={{ marginBottom: '16px' }}
            />

            <CheckboxComponent
                label="Active? *"
                field={{
                    ...formik.getFieldProps('isActive'),
                    onChange: () => formik.handleChange('isActive'),
                }}
                form={formik}
                style={{ marginBottom: '16px' }}
            />

            <ButtonComponent
                type="submit"
                label={formik.isSubmitting ? 'Submitting...' : 'Submit'}
                disabled={formik.isSubmitting}
                fullWidth
            />
        </form>
    );
};

export default AddSubscriptionPlan;
